import _capitalize from 'lodash/capitalize';
export default {
    methods: {
        capitalize(value) {
            if (!value) return '';
            value = value.toString();
            return _capitalize(value);
        }
    }
}
